import api from '../api'

export async function securitySearch (input, hideFixedIncome) {
  let query

  // Escape special Solr operators
  const escapedInput = input
    .replace(/~/g, '\\~')
    .replace(/\(/g, '\\(')
    .replace(/\)/g, '\\)')

  if (escapedInput.includes(' ')) {
    query = `companyname:*${escapedInput.replace(/ /g, String.raw`\ `)}*`
  } else {
    query = `(symbol:${escapedInput} OR symbol:${escapedInput}* OR companyname:*${escapedInput}* OR cusip:${escapedInput}*)`
  }

  if (hideFixedIncome) {
    query = query + ' AND isFixedIncome:false'
  }

  const response = await api.request({
    method: 'get',
    url: '/solr/web_canari/select',
    otcAPI: true,
    internalAPI: true,
    params: {
      q: query,
      rows: 10
    }
  })

  return response.data.response || response
}
